module.exports = __webpack_public_path__ + "static/media/wifiqube-5.701615ec.jpg";